import { Navigate, useLocation } from 'react-router-dom';
import useUser from 'src/hooks/useUser';
import logging from 'src/services/logging';

import { Backdrop, CircularProgress } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

const AdminRoute = ({ children }: Props) => {
  const { dbUser, fetchingUser } = useUser();
  const location = useLocation();

  logging.info(`Loading: ${fetchingUser}`, 'AdminRoute');
  if (fetchingUser) {
    return (
      <Backdrop open={fetchingUser}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  }

  if (!dbUser?.isHokage) {
    logging.warn('No admin detected, redirecting.', 'AdminRoute');
    return <Navigate to='/' state={{ from: location }} replace />;
  }

  logging.info('Show admin children.', 'AdminRoute');
  return <>{children}</>;
};

export default AdminRoute;
